module.exports = __webpack_public_path__ + "assets/img/2a05-io.svg";